import { GetApiQueryByUrl, GetApiResponseByUrl } from '@crossbeam/openapi';

import { computedAsync } from '@vueuse/core';
import { Ref, ref } from 'vue';

import { crossbeamApi } from '@/api';
import { captureException } from '@/errors';

export type McpUsageResponse = GetApiResponseByUrl<'/v0.1/mcp-usage'>;
export type McpUsageTimePeriod =
  GetApiQueryByUrl<'/v0.1/mcp-usage'>['time_period'];

export default function useMcpUsage(timePeriod: Ref<McpUsageTimePeriod>) {
  const isLoading = ref(true);
  const error = ref<unknown>(null);

  const data = computedAsync<McpUsageResponse | null>(
    async () => {
      const { data: response, error: apiError } = await crossbeamApi.GET(
        '/v0.1/mcp-usage',
        {
          params: {
            query: {
              time_period: timePeriod.value,
            },
          },
        },
      );
      if (apiError) {
        captureException(apiError);
        error.value = apiError;
        return null;
      }
      error.value = null;
      return response ?? null;
    },
    null,
    isLoading,
  );

  return { data, isLoading, error };
}
